import { useEffect, useState } from 'react';
import { Button, Input, Checkbox, Form,message } from 'antd';
import { useNavigate } from "react-router-dom";
import axios from 'axios';


const Login = () => {

  const [loginData, setLoginData] = useState({});
  const [form] = Form.useForm();
  const navigate = useNavigate();
  // console.log(loginData)

  const onFinish = async (values) => {
    
    try {

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/login`, values);
      setLoginData(response.data);
     sessionStorage.setItem("user",JSON.stringify(response.data));
     sessionStorage.setItem("kbs",JSON.stringify([]));
     message.success('Login Successful');

     setTimeout(() => {
      // Redirect the user to the dashboard
      navigate("/");
    }, 2000);
    } catch (error) {
      // console.log(error.response.data.msg);
      message.error(error.response.data.msg);
    }
  }

  return (
    <div className='loginWrapper'>
      <div className="headingWrapper">
        <img src='/login.png'></img>
      </div>
      <div className="loginFormWrapper">
     
        <div className='loginForm'>
          <Form

            form={form}
            onFinish={onFinish}
            autoComplete="off"
            id="loginForm"
            className="loginForm" // Add an ID to the form
            layout="vertical"
          >
               <h2 className='secondary'>Sign In</h2>
            <div className='formLayout'>
            
                <Form.Item label='Email' name='email' rules={[{ required: true, message: 'Please enter your email' }]}>
                  <Input type='text'/>
                </Form.Item>
                <Form.Item label='Password'  name='password' rules={[{ required: true, message: 'Please enter your password' }]}>
                  <Input type='password'/>
                </Form.Item>
            </div>
            <Button key='submit' type='primary' htmlType="submit" form='loginForm'>
              Login
            </Button>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default Login

